/* global instantsearch */
// {"first_name":"Crystal","last_name":"Devitt","addresses":{},"gender":"female","age":46,"birth_date":"1977-11-25","email":"monchiquita@gmail.com","name":"Crystal Devitt"}

import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';
import debounce from 'lodash.debounce';
import {
    currentRefinements
} from 'instantsearch.js/es/widgets';

function timeSince(date) {

    var seconds = Math.floor((Date.now() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
        return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
}

function googleAnalyticsMiddleware() {
    const sendEventDebounced = debounce(() => {
        // crazy but true leave as a for production
        // gtag('event', 'page_view', {
        a('event', 'page_view', {
            page_location: window.location.pathname + window.location.search,
        });
    }, 3000);

    return {
        onStateChange() {
            sendEventDebounced();
        },
        subscribe() {},
        unsubscribe() {},
    };
}

// const TYPESENSE_API_KEY = "NCF9nxUpkuuxRnRHwDOm2a1tmnzabjik";

// const TYPESENSE_API_KEY = "LlA8twqNqXHYZDUFml6sQYG16KShHCxY";
// all collection search only

// const TYPESENSE_API_KEY =  "GGvyHonOH3SQBNNhkyCLr6XnuXFJNHIw";
let TYPESENSE_API_KEY = "GGvyHonOH3SQBNNhkyCLr6XnuXFJNHIw";
const profile = JSON.parse(localStorage.getItem("tidalforce-profile"))
// debugger
if (profile === null) {
    alert("please contact ralph@tidalforce.org to purchase a subscription")
}
console.log("profile", profile)
if (profile.readkey) {
    console.log("profile.readkey", profile.readkey)
    TYPESENSE_API_KEY = profile.readkey
    //alert(profile.readkey)
}


const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
        apiKey: TYPESENSE_API_KEY, // Be sure to use an API key that only allows searches, in production
        nodes: [{
            /*
              host: 'localhost',
              port: '8108',
              protocol: 'http',
              */
            // host: "1ztriixxhgxh.share.zrok.io",
            // host: "8iv15rppo02e.share.zrok.io",
            host: "tidalforce.share.zrok.io",
            port: "443",
            protocol: "https",
        }, ],
    },
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  queryBy is required.
    //  filterBy is managed and overridden by InstantSearch.js. To set it, you want to use one of the filter widgets like refinementList or use the `configure` widget.
    geoLocationField: 'location',
    additionalSearchParameters: {
        // queryBy: 'title,authors',
        // queryBy: 'data.PropAddr,data.PropOwner',
        // queryBy: "data.searchkey, data.id, data.BillYear, data.PropAddr, data.PropAssessed, data.PropOwes, data.PropOwner, data.description, data.eventid",
        query_by: "filter,snippet,loc,lastmod,source,contact",
        // filter_by: "priceINT:[1000..6000]",
    },
});
const searchClient = typesenseInstantsearchAdapter.searchClient;
const format = new Intl.NumberFormat("en-US", {
    style: "currency",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    currency: "USD",
});
const index = "rentals";

const search = instantsearch({
    searchClient,
    // indexName: 'books',
    // indexName: 'algolia-store',
    indexName: index,
    // routing: true,
    routing: {
        stateMapping: {
            stateToRoute(uiState) {
                // ...
                if (window.search.helper) {
                    const currentfilter = window.search.helper.getQuery();
                    // console.log(`debug: ${JSON.stringify(currentfilter)}`);
                    if (currentfilter.aroundLatLng) {
                        uiState[index].configure.aroundLatLng = currentfilter.aroundLatLng;
                    }
                    if (currentfilter.aroundRadius) {
                        uiState[index].configure.aroundRadius = currentfilter.aroundRadius;
                    }
                }
                // console.log(`stateToRoute: ${JSON.stringify(uiState)}`);
                return uiState;
            },
            routeToState(routeState) {
                // ...
                if (window.search.helper) {
                    const currentfilter = window.search.helper.getQuery();
                    // console.log(`debug: ${JSON.stringify(currentfilter)}`);
                }
                // console.log(`routeToState: ${JSON.stringify(routeState)}`);
                return routeState;
            },
        }
        /*
        instantsearch.routers.history({

          createURL({ qsModule, location, routeState }) {
            const currentfilter=window.search.helper.getQuery();
            console.log(`debug: ${JSON.stringify(currentfilter)}`);

            const indexState = routeState[index] || {};
            const { origin, pathname, hash, search } = location;
            // grab current query string, remove the trailing `?` and convert to object
            const queryParameters = qsModule.parse(search.slice(1)) || {};

            // if there is an active search
            if (Object.keys(indexState).length ){
              // merge the search params with the current query params
              Object.assign(queryParameters, routeState);
            }else{
              // remove the search params
              delete queryParameters[index];
            }

            let queryString = qsModule.stringify(queryParameters);

            if(queryString.length){
              queryString = `?${queryString}`;
            }

            return `${origin}${pathname}${queryString}${hash}`;
          },
        })
          */
    }
});
window.search = search;

// ${item._highlightResult.title.value}
// ${item._highlightResult.authors.map((a) => a.value).join(', ')}
// 30 days
const now_seconds = Math.floor(new Date().getTime() / 1000);
const past30days_seconds = Math.floor(new Date().getTime() / 1000) - (30 * 24 * 60 * 60);
const past7days_seconds = Math.floor(new Date().getTime() / 1000) - (7 * 24 * 60 * 60);
const past24hours_seconds = Math.floor(new Date().getTime() / 1000) - (1 * 24 * 60 * 60);
const pasthour_seconds = Math.floor(new Date().getTime() / 1000) - (1 * 60 * 60);

search.addWidgets([
    instantsearch.widgets.searchBox({
        container: '#searchbox',
        placeholder: "Search for zip, address, etc.",
        autofocus: true,
    }),
    instantsearch.widgets.configure({
        hitsPerPage: 4,
        // filters: "priceINT:[1000..6000]",
        // filters: "priceINT:[1000..6000] && lastmodINT:>1724008973",
        filters: `priceINT:[1000..6000] && lastmodINT:>${past30days_seconds}`,
        // aroundLatLng: '39.930984, -75.1614913',
        // aroundRadius: 1000,
    }),
    instantsearch.widgets.clearRefinements({
        container: '#clear-refinements',
    }),
    instantsearch.widgets.stats({
        container: '#stats',
    }),
    instantsearch.widgets.refinementList({
        container: '#refinement-list-price',
        attribute: "priceINT",
        searchable: true,
        limit: 10,
        searchablePlaceholder: "Search for Price",
    }),
    instantsearch.widgets.refinementList({
        container: '#refinement-list-beds',
        attribute: "beds",
        searchable: true,
        limit: 10,
        searchablePlaceholder: "Search for beds",
    }),
    instantsearch.widgets.refinementList({
        container: '#refinement-list-baths',
        attribute: "baths",
        searchable: true,
        limit: 10,
        searchablePlaceholder: "Search for baths",
    }),
    instantsearch.widgets.refinementList({
        container: '#refinement-list-source',
        attribute: "source",
        searchable: true,
        limit: 10,
        searchablePlaceholder: "Search for Source",
    }),
    instantsearch.widgets.refinementList({
        container: '#refinement-list-contacttype',
        attribute: "contacttype",
        searchable: true,
        limit: 10,
        searchablePlaceholder: "Search for Contact Type",
    }),
    instantsearch.widgets.numericMenu({
        container: '#lastmod-menu',
        attribute: 'lastmodINT',
        items: [{
                label: 'Any time'
            },
            {
                label: 'Past hour',
                start: pasthour_seconds
            },
            {
                label: 'Past 24 hours',
                start: past24hours_seconds
            },
            {
                label: 'Past week',
                start: past7days_seconds
            },
            {
                label: 'Past month',
                start: past30days_seconds
            },
        ],
    }),
    instantsearch.widgets.rangeSlider({
        container: '#lastmod-slider',
        attribute: 'lastmodINT', // The attribute you want to filter on
        min: past30days_seconds, // Minimum value for the slider
        max: now_seconds, // Maximum value for the slider
        // tooltips: false,
        tooltips: {
            format: function(formattedValue) {
                //debugger;
                const range = new Date(formattedValue * 1000);
                console.log(`range: ${range}`);
                return range;
            }
        },
    }),
    instantsearch.widgets.hits({
        transformItems(items, {
            results
        }) {
            // console.log('debug transform items', items);
            // console.log('debug transform results', results);
            document.title = `Rental search: ${results.query.substring(0,30)} | Tidalforce`;
            return items.map((item, index) => ({
                ...item,
                position: {
                    index,
                    page: results.page
                },
                stats: results.facets_stats,
                query: results.query,
            }));
        },
        container: '#hits',
        templates: {
            item(item) {
                // console.log("item",item);
                try {
                    // let text=item._highlightResult['Doc Date'].value;
                    // let text=item.loc;
                    let text = item.filter || item.id;
                    const LIMIT = 100;
                    const LIMIT2 = 1000;
                    const LIMIT3 = 40;
                    text = text.replace(/[\/]/g, ' ').replace(/\?.*/, '');
                    if (text.length > LIMIT) {
                        // text = text.substring(0, LIMIT) + '...';
                        text = text.slice(-LIMIT);
                    }

                    let nearbylink = "";
                    let rawtext=""
                    let contacttext=""
                    // console.log(`queryparameters: ${search.helper.getQuery().filter}`);
                    const currentfilter = search.helper.getQuery();
                    const action = `javascript:window.search.helper.setQueryParameter('aroundLatLng', '${item.location}').setQueryParameter('aroundRadius', '2000m').search();`;
                    // const action=`javascript:instantsearch.widgets.configure({ aroundLatLng: '${String(item.location)}', aroundRadius: '2000m'  });`;
                    const actionclear = `javascript:window.search.helper.setQueryParameter('aroundLatLng').setQueryParameter('aroundRadius').search();`;
                    if (text) {
                        text = text.substring(0, LIMIT3)
                    }
                    if (item.location) {
                        nearbylink = `<a href="${action}">Nearby<!--${item.location}--></a> | 
         <a href="${actionclear}">All</a>`;
                        if (currentfilter.aroundLatLng === String(item.location)) {
                            nearbylink += " <b>SELECTED</b>";
                        }
                    }
          if(item._highlightResult.raw){
          rawtext=item._highlightResult.raw.value.substring(0,LIMIT2)
          }
          if(item.contact){
          contacttext=JSON.stringify(JSON.parse(item.contact),"",3).substring(0,LIMIT2)
          }
                    return `
        <div>
          <div class="hit-name">
            <a target="_blank" href="${item.loc}">${format.format(item.priceINT)} ${text}</a>
          </div>
          <div class="hit-authors">
          </div>
          <div class="hit-publication-year">Updated <b>${timeSince(item.lastmodINT*1000)} ago</b> ${item.lastmod}</div>
          <div class="hit-rating">Cache: ${item._highlightResult.snippet.value.substring(0,LIMIT2)} ${nearbylink}</div>
          <!-- <div class="hit-rating">Raw: ${rawtext}</div> -->
          <div class="hit-rating">Contact: ${contacttext}</div>
          <div class="stats">(query "${item.query}" sum ${format.format(item.stats.priceINT.sum)} average ${format.format(item.stats.priceINT.avg)} max ${format.format(item.stats.priceINT.max)}  min ${format.format(item.stats.priceINT.min)} filter: ${currentfilter.filters||''} ${currentfilter.aroundLatLng||''}  ${currentfilter.aroundRadius?currentfilter.aroundRadius+'m':''}) Created ${timeSince(item.createdINT*1000)} ago (${new Date(item.createdINT*1000)})</div>
        </div>
      `;
                } catch (e) {
                    //console.log(`TRACE: ${JSON.stringify(item)}`);
                    console.log("item", item);
                    return `<div>ISSUE ${e} ${JSON.stringify(item)}</div>`;
                }
            },
        },
    }),
    instantsearch.widgets.pagination({
        container: '#pagination',
    }),
    currentRefinements({
        container: '#current-refinements',
    }),

    instantsearch.widgets.sortBy({
        container: '#sort-by',
        items: [{
                label: "Date (asc)",
                value: `${index}/sort/lastmodINT:asc`
            },
            {
                label: "Date (desc)",
                value: `${index}/sort/lastmodINT:desc`
            },
            {
                label: "Price (asc)",
                value: `${index}/sort/priceINT:asc`
            },
            {
                label: "Price (desc)",
                value: `${index}/sort/priceINT:desc`
            },
        ],
    }),
]);

search.use(googleAnalyticsMiddleware);

window.onerror = function(message, file, line, col, error) {
    alert("Error occurred: " + error.message + ". that's all we know. Please wait 5 minutes before retrying. (onerror)");
    return false;
};

window.addEventListener('unhandledrejection', function(e) {
    // alert("Error occurred: message: " + e.reason.message + " promise: " + e.reason.promise + ". that's all we know. Please wait 5 minutes before retrying. (unhandledrejection)");
    // Check if the reason is an Error object, which typically contains a stack trace
    if (e.reason instanceof Error) {
        console.error('Stack Trace:', e.reason.stack);
        console.error('e:', e.reason);
        // alert('Stack Trace:' + e.reason.stack + " " + JSON.stringify(e));
    } else {
        // If the reason is not an Error object, you can still log its value
        console.error('Rejection Reason (not an Error object):', event.reason);
    }

    // Optionally, prevent the default browser handling of unhandled rejections
    // event.preventDefault();
    alert("Error occurred: message: " + e.reason.message + ". that's all we know. Please wait 5 minutes before retrying. (unhandledrejection)\n\n Stack Trace: " + e.reason.stack);
})

try {
    search.start();
} catch (e) {
    console.log(e)
    alert("Error occurred: " + e  + ". that's all we know. Please wait 5 minutes before retrying. (catch)");
}

// search.helper.setQueryParameter('aroundLatLng', this.value).search();
// search.helper.setQueryParameter('aroundLatLng', '39.930984, -75.1614913').setQueryParameter('aroundRadius', '1000m').search();
